import { IconInfoRegular } from '@croquiscom-pvt/zds';
import { Text } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

interface Props {
  text: string;
}

export const StoreDealText = ({ text }: Props) => {
  return (
    <Wrapper>
      <IconInfoRegular width={18} height={18} color='textSecondary' style={{ minWidth: 18, marginRight: 2 }} />
      <Text variant='Body_13_Regular' color='textSecondary' style={{ wordBreak: 'keep-all', lineHeight: '150%' }}>
        {text}
      </Text>
    </Wrapper>
  );
};

const Wrapper = styled.p`
  display: flex;
  padding-top: 4px;
`;
